function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M102,84.8H31.7c-2.4,0-4.4-2-4.4-4.4V33.8c0-2.4,2-4.4,4.4-4.4H102c2.4,0,4.4,2,4.4,4.4v46.6                                     C106.4,82.8,104.4,84.8,102,84.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M101.3,82.3H32.5c-1.5,0-2.8-1.2-2.8-2.8v-3.7h74.3v3.7C104.1,81.1,102.8,82.3,101.3,82.3z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 118,
  cy: 77.5,
  r: 3.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 9,
  cy: 55.5,
  r: 2.8
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st4",
  cx: 102.6,
  cy: 32.2,
  r: 14.4
}), /*#__PURE__*/React.createElement("rect", {
  x: 101.4,
  y: 24.7,
  className: "st5",
  width: 2.7,
  height: 14.8
}), /*#__PURE__*/React.createElement("rect", {
  x: 101.4,
  y: 24.7,
  transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 134.8133 -70.6572)",
  className: "st5",
  width: 2.7,
  height: 14.8
})), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 29.7,
  y1: 73.5,
  x2: 104.1,
  y2: 73.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 36.2,
  y1: 60,
  x2: 51.4,
  y2: 60
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 36.2,
  y1: 52.7,
  x2: 57.2,
  y2: 52.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 47.8,
  y1: 45.6,
  x2: 57.2,
  y2: 45.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 15.1,
  y1: 9.8,
  x2: 17.6,
  y2: 12.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 21.5,
  y1: 16.1,
  x2: 24,
  y2: 18.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 98.2,
  y1: 78.6,
  x2: 101.6,
  y2: 78.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 88.5,
  y1: 78.6,
  x2: 96.1,
  y2: 78.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 52.3,
  y1: 94.5,
  x2: 80.2,
  y2: 94.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st7",
  x1: 82.1,
  y1: 94.5,
  x2: 116.9,
  y2: 94.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st7",
  x1: 15.1,
  y1: 94.5,
  x2: 49.9,
  y2: 94.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 40.4,
  y1: 37.3,
  x2: 40.4,
  y2: 47.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 36.3,
  y1: 44.1,
  x2: 41,
  y2: 48.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 44.6,
  y1: 44.3,
  x2: 39.8,
  y2: 49
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 62.2,
  y1: 87.1,
  x2: 62.2,
  y2: 94.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 71.3,
  y1: 87.1,
  x2: 71.3,
  y2: 94.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 64.7,
  y: 87.1,
  className: "st8",
  width: 4,
  height: 5.3
}), /*#__PURE__*/React.createElement("g", {
  className: "st9"
}, /*#__PURE__*/React.createElement("rect", {
  x: 124,
  y: 52.5,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 76.0069 -71.7334)",
  className: "st5",
  width: 1.2,
  height: 6.7
}), /*#__PURE__*/React.createElement("rect", {
  x: 124,
  y: 52.5,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 252.2083 7.2953)",
  className: "st5",
  width: 1.2,
  height: 6.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: 124.6,
  cy: 55.9,
  r: 2
})), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 15.1,
  y1: 18.6,
  x2: 17.6,
  y2: 16.1
}), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: 21.5,
  y1: 12.2,
  x2: 24,
  y2: 9.7
}));

var SvgAddComputerNew = function SvgAddComputerNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133.2 105",
    style: {
      enableBackground: "new 0 0 133.2 105"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddComputerNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_computer_new.ad642c8b.svg";
export { ForwardRef as ReactComponent };